import { Alert } from "@nabble/ui";
import { PASSWORD_VIOLATIONS } from "../errors";

/** The server's reasons for rejecting a password, as a plain list. */
export function PasswordViolationsAlert({ title, violations }: { title: string; violations: string[] }): React.JSX.Element {
  return (
    <Alert tone="danger" title={title}>
      <ul style={{ margin: 0, paddingLeft: 18 }}>
        {violations.map((v) => (
          <li key={v}>{PASSWORD_VIOLATIONS[v] ?? v}</li>
        ))}
      </ul>
    </Alert>
  );
}
